<script lang="ts">
  import LoginForm from "./LoginForm.svelte";

  let { onclose }: { onclose: () => void } = $props();

  function onkeydown(ev: KeyboardEvent) {
    if (ev.key === "Escape") {
      onclose();
    }
  }
</script>

<button class="fixed inset-0 z-10 bg-black/20" aria-label="Close login dialog" onclick={onclose}></button>
<div
  role="dialog"
  tabindex="0"
  {onkeydown}
  class="fixed z-20 center-with-translate w-[min(420px,calc(100vw-2rem))] rounded-lg bg-white p-6 text-sm shadow-xl dark:bg-gray-900 dark:text-gray-100"
>
  <div class="mb-5 flex items-center justify-between">
    <div class="text-base font-semibold">Login to Sumatra Online</div>
    <button type="button" title="Cancel" onclick={onclose} class="rounded px-2 py-1 hover:bg-gray-100 dark:hover:bg-gray-800">x</button>
  </div>

  <LoginForm />
</div>
